<template>
  <div class="form-created-account">
    <h1>
      Congratulations! Your CN account has been created.
    </h1>

    <h2 class="font-weight-bold">
      Your CN number is:
    </h2>
    <p class="font-weight-bold cn-number">
      {{ cn_number }}
    </p>

    <p>
      Remember this CN number to log in to the CN in the future.
    </p>

    <h2>
      The URL of your lifelong CN ePortfolio (profile) is:
    </h2>
    <p class="font-weight-bold">
      <a
        href="javascript:;"
        role="button"
        title="ePorfolio link"
        @click="redirect(`${host}/${cn_number}`)"
        >{{ `${host}/${cn_number}` }}</a
      >
    </p>

    <p class="hint">
      An activitation email has been sent to you. Please make sure to activate
      your account <b>within the next 24 hours</b>.
    </p>

    <div v-if="signin_redirection_page">
      <a
        href="javascript:;"
        @click="redirect(signin_redirection_page)"
        role="button"
        class="btn btn-success d-block"
        title="Take Me to the CN"
      >
        Take Me to the CN
      </a>
    </div>
    <div v-else>
      <a
        href="javascript:;"
        @click="redirect(host)"
        role="button"
        class="btn btn-success mb-3 d-flex flex-column"
        title="Take Me to the CN Home Page"
      >
        <b>Take Me to the CN Home Page</b>
        <small>To network and engage in CN courses</small>
      </a>
      <a
        href="javascript:;"
        @click="redirect(`${host}/${cn_number}`)"
        role="button"
        class="btn btn-primary d-flex flex-column"
        title="Take Me to My CN ePortfolio"
      >
        <b>Take Me to My CN ePortfolio</b>
        <small
          >To start building your ePortfolio and prepare for the job
          market</small
        >
      </a>
    </div>
    <b-modal ref="my-modal" title="Message">
      <p v-text="message"></p>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { CN_HOST } from "@/configs";
export default {
  name: "form-created-account",
  props: {
    host: {
      type: String,
      default: CN_HOST
    }
  },
  data() {
    return {
      message: ""
    };
  },
  computed: {
    ...mapState("user", ["cn_number", "password"]),
    ...mapState("siteBrand", ["signin_redirection_page"])
  },
  methods: {
    ...mapActions("user", ["login"]),
    redirect(to) {
      this.login({
        username: this.cn_number,
        password: this.password
      })
        .then(res => {
          const { path } = res;
          window.location.href = `${path}/${encodeURIComponent(to)}`;
        })
        .catch(res => {
          let errors = res?.data?.errors;
          if (errors && errors.length) {
            this.message = errors.join(",");
            this.$refs["my-modal"].show();
          }
        });
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
.form-created-account {
  h1,
  h2,
  p {
    font-size: 14px;
  }
  .cn-number {
    font-size: 100px;
    text-transform: uppercase;
  }
  .hint {
    font-size: 13px;
    color: red;
  }
}
</style>
